var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showProfile && _vm.editProfile !== null)?_c('UserProfileFormModal',{attrs:{"userId":_vm.editProfile.user_id,"title":"Profile"},on:{"close":function($event){return _vm.toggleProfile(false)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }